import React from 'react'
import ReactSlider from 'react-slider'

import styles from './styles.module.css'

const PriceSlider = ({ onChange, min_price, max_price, defaultValue }) => {
  return (
    <div className={styles.container}>
      <ReactSlider
        className={styles.slider}
        thumbClassName={styles.thumb}
        trackClassName={'slider-track'}
        defaultValue={defaultValue}
        renderThumb={(props, state) => <div {...props}></div>}
        pearling
        onChange={onChange}
      />
      <div
        style={{ marginTop: 8 }}
        className="w-100 d-flex justify-content-between align-items-center"
      >
        <span className={styles.label}>
          تا {max_price ? max_price?.toLocaleString() : 300000} تومان
        </span>
        <span className={styles.label}>
          از {min_price ? min_price?.toLocaleString() : 0} تومان
        </span>
      </div>
    </div>
  )
}

export default PriceSlider
